module.exports = __webpack_public_path__ + "img/Google-Play.c8c587fc.svg";